import React from "react";
import "./PerfectPlace.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import image1 from "../../../../assets/perftectimg(1).png";
import image2 from "../../../../assets/perfectimg(2).png";

const PerfectPlace = () => {
  return (
    <div className="py-5 perfect-place">
      <Row className="gx-0 d-flex justify-content-center align-items-center">
        <div className="text-center pb-4  perfect-place-head">
          <h2>L'Endroit Idéal Pour Un</h2>
          <h2>Expérience Exceptionnelle</h2>
          {/* <p>ALL DAY EXPERIENCE</p> */}
        </div>
        <Col
          xs="12"
          lg="4"
          className="d-flex justify-content-center align-items-center"
        >
          <img className="img-fluid experience-img experience-img1" src={image1} alt="" />
        </Col>
        <Col
          xs="12"
          lg="4"
          className="d-flex justify-content-center align-items-center pt-3 pt-md-0"
        >
          <img className="img-fluid experience-img experience-img2" src={image2} alt="" />
        </Col>
        <Col
          xs="11"
          lg="4"
          className="d-flex justify-content-center align-items-center"
        >
          <div className="pt-5 p-md-5 text-center text-md-start">
            <p>
              Le jour, Delicioz offre une plaque tournante pour rencontrer des
              amis et des collègues avec une carte des vins bien conçue, un
              service discret mais professionnel et des menus sophistiqués, le
              tout livré dans un cadre décontracté.
            </p>
            <p>
              La nuit, la scène est prête pour toutes les occasions. Des tables
              intimes pour deux aux petits groupes ou aux grands événements
              privés. Notre attention inégalée aux détails et notre forte
              concentration sur la livraison des meilleures expériences
              culinaires sont conçues pour dépasser les attentes.
            </p>
            <h4 className="text-capitalize" style={{ color: "#F7EA80" }}>
              Demande De Réservation
            </h4>
            <h2 className="text-center text-md-start">05 67 48 47 33</h2>
            <div className="">
              <button className="animated-button victoria text-center text-capitalized">
                faire une réservation
              </button>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PerfectPlace;
